<template>
  <gkButton class="com-icon-button" :class="{toggle: toggle}" @click="$emit('click')" v-if="isMobile">
    <i class="iconfont" v-html="iconfont"></i>
    <slot name="label">
      <p v-if="label">{{label}}</p>
    </slot>
  </gkButton>

  <div class="com-icon-button" v-else>
    <gkButton color="icon" class="iconfont" :class="[icon, {toggle: toggle}]" v-html="iconfont" @click="$emit('click')" />
    <slot name="label">
      <p v-if="label">{{label}}</p>
    </slot>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

import {mapState} from 'vuex'
import gkButton from 'gkui/button'

/**
 * 文章详情的 ICON 按钮
 * @module component/IconButton
 * @extends gkButton
 * @example
 * <IconButton icon="weixin" label="微信" />
 * <IconButton icon="favorite" label="收藏" :toggle="isFavorite" @click="toggleFavorite" />
 */
export default {
  name: 'icon-button',
  /**
   * 引用的组件
   * @prop {Component}  gkButton  按钮组件
   */
  components: {
    gkButton
  },
  /**
   * 传入数据
   * @prop {String}         [label='']       Icon 文案
   * @prop {String}         [icon='']        iconfont Unicode
   * @prop {Number|Boolean} [toggle=false]   状态是否已被激活
   */
  props: {
    label: VueTypes.string.def(''),
    icon: VueTypes.string.def(''),
    toggle: VueTypes.oneOfType([Boolean, Number]).def(false)
  },
  /**
   * 计算属性
   * @prop {Object} isMobile  是否为移动端
   * @prop {String} iconfont  不同按钮的 iconfont Unicode[favorite, comment, weixin, weibo]
   */
  computed: {
    ...mapState([
      'isMobile'
    ]),
    iconfont () {
      switch (this.icon) {
        case 'favorite':
          // return this.toggle ? '&#xe60b;' : '&#xe642;'
          return '&#xe678;'
        case 'comment':
          return '&#xe677;'
        case 'weixin':
          return '&#xe67d;'
        case 'weibo':
          return '&#xe67e;'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.com-icon-button {
  // @extend %animateFontGray;

  cursor: pointer;

  & .iconfont.favorite.toggle {
    // background: $blue;
    color: $blue;
  }

  & p {
    // padding-top: 10px;
    text-align: center;
    color: #8A8A8A;
    @include lineFont(12, 400);
  }

  & .iconfont {
    color: #202124;
    font-size: 24px !important;
  }
}

@media screen and (max-width: 768px) {
  .com-icon-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75px; height: 28px;
    background: $lightGray;
    border-radius: 28px;
    line-height: 16px;
    color: $gray;

    &:hover,
    &:active {
      color: $gray;
    }

    &.toggle,
    &.toggle:hover,
    &.toggle:active {
      background: $blue;
      color: #FFF;
    }

    & p {
      padding-top: 0; margin-left: 6px;
      @include font(14, 400);
    }
  }
}

</style>
